<template>
  <div>
    <div v-for="(item, index) in order" :key="index">
      <v-card-subtitle>{{ item.groupText }}</v-card-subtitle>
      <div v-for="(permission, index) in permissions" :key="index">
        <v-switch
          :disabled="!editable"
          class="ml-6 mt-0"
          v-if="permission.groupKey === item.groupKey"
          v-model="permission.selected"
          :label="`${permission.name} - ${permission.description}`"
          @change="$emit('onChangePermission', index)"
        />
      </div>
      <v-divider />
    </div>
  </div>
</template>

<script>
import { uniq } from "lodash";

export default {
  name: "PermissionsContainer",
  props: {
    permissions: {
      type: Array,
      default: () => {
        return [];
      },
    },
    editable: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      order: [
        {
          groupKey: "order",
          groupText: "Order Management",
        },
        {
          groupKey: "customers",
          groupText: "Customer Management",
        },
        {
          groupKey: "users",
          groupText: "User Management",
        },
        {
          groupKey: "products",
          groupText: "Product Management",
        },
        {
          groupKey: "distributors",
          groupText: "Distributor Management",
        },
        {
          groupKey: "associates",
          groupText: "Associate Management",
        },
        {
          groupKey: "administrative",
          groupText: "Administrative Management",
        },
      ],
    };
  },
};
</script>
